'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = require('react-bootstrap');

var _CodeEditor = require('./CodeEditor');

var _CodeEditor2 = _interopRequireDefault(_CodeEditor);

var _Panel = require('./Panel');

var _Panel2 = _interopRequireDefault(_Panel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Component to render the given swagger spec's schema object
 */
var JsonSchema = function (_React$Component) {
	_inherits(JsonSchema, _React$Component);

	function JsonSchema(props) {
		_classCallCheck(this, JsonSchema);

		var _this = _possibleConstructorReturn(this, (JsonSchema.__proto__ || Object.getPrototypeOf(JsonSchema)).call(this, props));

		_this.json = JSON.stringify(_this.props.schema, null, 2);
		return _this;
	}

	_createClass(JsonSchema, [{
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps() {
			this.json = JSON.stringify(this.props.schema, null, 2);
		}
	}, {
		key: 'render',
		value: function render() {
			var _props = this.props,
			    title = _props.title,
			    theme = _props.theme,
			    expandable = _props.expandable,
			    expanded = _props.expanded;


			var editor = _react2.default.createElement(_CodeEditor2.default, {
				code: this.json,
				mode: 'json',
				json: true,
				theme: theme,
				lineNumbers: false,
				lineWrapping: true,
				nocursor: true,
				readOnly: true
			});
			if (expandable) {
				return _react2.default.createElement(
					_reactBootstrap.Accordion,
					{ id: title },
					_react2.default.createElement(
						_Panel2.default,
						{
							independent: true,
							eventKey: 'definitions',
							hasIcon: true,
							defaultExpanded: expanded,
							bsStyle: 'default',
							bsSize: 'small',
							header: title,
							animate: false,
							borders: false
						},
						editor
					)
				);
			} else {
				return _react2.default.createElement(
					'div',
					{ id: title },
					title && _react2.default.createElement(
						'h4',
						null,
						title
					),
					editor
				);
			}
		}
	}]);

	return JsonSchema;
}(_react2.default.Component);

JsonSchema.propTypes = {
	/**
  * Swagger spec's Schema Object
  * (https://github.com/OAI/OpenAPI-Specification/blob/master/versions/2.0.md#schemaObject)
  */
	schema: _propTypes2.default.object.isRequired,

	/**
  * optional title of the tree (overrides the title property)
  */
	title: _propTypes2.default.string,

	/**
  * color theme for the rendered component
  */
	theme: _propTypes2.default.oneOf(['dark', 'red', 'green', 'blue', 'eclipse']),

	/** needed if you need to make it hyperlinkable */
	id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),

	/**
  * Renders a toggleable accordion container
  */
	expandable: _propTypes2.default.bool,

	/**
  * Expands on default
  */
	expanded: _propTypes2.default.bool
};

JsonSchema.defaultProps = {
	theme: 'eclipse',
	expandable: false,
	expanded: true
};

var _default = JsonSchema;
exports.default = _default;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(JsonSchema, 'JsonSchema', 'src/components/JsonSchema.jsx');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/components/JsonSchema.jsx');
}();

;